import api from '@/api';

function hasProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

export default {
  list: (docType, filter, listFavourites) => {
    let apiEndpoint;

    if (listFavourites) {
      apiEndpoint = `/${docType.singular}management/${docType.plural}/favourites`;
    } else {
      apiEndpoint = `/${docType.singular}management/${docType.plural}`;
    }

    return new Promise((resolve, reject) => {
      api()
        .put(`${apiEndpoint}`, { filter })
        .then((response) => {
          const returnObj = {
            documents: response.data.data[docType.singular],
            filterTotal: response.data.meta.filter_total,
          };
          resolve(returnObj);
        })
        .catch((error) => {
          if (error.response && hasProp(error.response.data.data, docType.singular)) {
            const returnObj = {
              documents: error.response.data.data[docType.singular],
              filterTotal: error.data.meta.filter_total,
            };
            resolve(returnObj);
          } else {
            reject(error.response.data);
          }
        });
    });
  },

  create: (docType, documentData) => {
    const apiEndpoint = `/${docType.singular}management/${docType.singular}`;

    return new Promise((resolve, reject) => {
      api()
        .put(apiEndpoint, { [docType.singular]: documentData })
        .then((response) => {
          if (hasProp(response.data.data, docType.singular)) {
            const document = response.data.data[docType.singular][0];
            resolve(document);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          if (error.response && hasProp(error.response.data.data, docType.singular)) {
            const document = error.response.data.data[docType.singular][0];
            resolve(document);
          } else {
            reject(error.response.data);
          }
        });
    });
  },

  read: (docType, documentId) => {
    const apiEndpoint = `/${docType.singular}management/${docType.singular}`;

    return new Promise((resolve, reject) => {
      api()
        .get(`${apiEndpoint}/${documentId}`)
        .then((response) => {
          const document = response.data.data[docType.singular][0];
          resolve(document);
        })
        .catch((error) => {
          if (error.response && hasProp(error.response.data.data, docType.singular)) {
            const document = error.response.data.data[docType.singular][0];
            resolve(document);
          } else {
            reject(error.response.data);
          }
        });
    });
  },

  update: () => {
    // TODO:
  },

  delete: (docType, documentId) => {
    const apiEndpoint = `/${docType.singular}management/${docType.singular}/${documentId}`;

    return new Promise((resolve, reject) => {
      api()
        .delete(apiEndpoint)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // -------------------------------------

  favourite: (docType, documentId) => {
    const apiEndpoint = `/${docType.singular}management/${
      docType.singular
    }/${documentId}/favourite`;

    return new Promise((resolve, reject) => {
      api()
        .put(apiEndpoint)
        .then((response) => {
          resolve(response.data.data[docType.singular][0]);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  unfavourite: (docType, documentId) => {
    const apiEndpoint = `/${docType.singular}management/${
      docType.singular
    }/${documentId}/unfavourite`;

    return new Promise((resolve, reject) => {
      api()
        .put(apiEndpoint)
        .then((response) => {
          resolve(response.data.data[docType.singular][0]);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  downloadReport: (docType, isAdmin) => {
    let apiEndpoint;

    if (isAdmin) {
      apiEndpoint = `/${docType.singular}management/report`;
    } else {
      apiEndpoint = `/${docType.singular}management/report/user`;
    }

    return new Promise((resolve, reject) => {
      api()
        .get(apiEndpoint, {
          responseType: 'blob',
          timeout: false,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
